import React, { FC,ReactElement } from 'react'

// style 
import '../../../../../_jutemplate/assets/css/custom.css'

// component
import { CardTitle } from './CardTitle'
import { CardContent } from './CardContent'

interface CardProps {
     bgColor:string;
     textColor:string;
     icon:ReactElement;
     title:string;
     content:string;
}


const Card:FC<CardProps> = ({bgColor,textColor,icon,title,content}) => {
  
  return (
    <div className='card px-5 py-4 rounded-3 justify-content-between dashboard-overview' style={{backgroundColor:bgColor,height:'120px'}}>
          <div className='d-flex align-items-center gap-3'>
               {icon}
               <CardTitle textColor={textColor}>{title}</CardTitle>
          </div>
          <CardContent>{content}</CardContent>
    </div>
  )
}

export default Card
